import moment, { Moment } from "moment";
import toast from "react-hot-toast";
import { jsPDF } from "jspdf";

import {
  BP_ICON,
  ECG_ICON,
  GLUCO_ICON,
  HEADER_LOGO,
  VINCENSE_ICON,
  WEIGHT_ICON } from
"./imagesConstants";
export const PROJECT_NAME = "Vincense";

const RESOLVED_BASE_URL = process.env.REACT_APP_BASE_URL;
if (!RESOLVED_BASE_URL) {
  // Fail loudly in dev/build so a missing env var doesn't silently fall back
  // to a stale URL and produce confusing network errors at runtime.
  throw new Error(
    "REACT_APP_BASE_URL is not set. Add it to web/.env.development or web/.env.production."
  );
}
export const BASE_URL: string = RESOLVED_BASE_URL;
// export const BASE_URL: string = "http://localhost:6227/graphql";
export var pluralize = require("pluralize");
export const ProjectName = "Vincense";

export const disableDate = (current: Moment | null): boolean => {
  return !!(current && current < moment().startOf("day"));
};
export const deliveryDateFormat = (
date: string | Date | undefined)
: string => {
  if (!date) return "";
  return moment(new Date(date)).format("DD MMM, dddd");
};

export const formatDate = (date: string | Date | undefined): string => {
  if (!date) return "";
  return moment(new Date(date)).format("DD MMM, YYYY");
};

export function indianCurrencyFormat(
amount: number = 0,
showZero: boolean = false)
: string {
  let amountStr = amount.toFixed(2); // Ensure two decimal places
  let [integerPart, fractionalPart] = amountStr.split(".");

  // Format the integer part
  let lastThreeDigits = integerPart.slice(-3);
  let otherDigits = integerPart.slice(0, -3);
  if (otherDigits) {
    lastThreeDigits = "," + lastThreeDigits;
  }
  otherDigits = otherDigits.replace(/\B(?=(\d{2})+(?!\d))/g, ",");
  let formattedInt = otherDigits + lastThreeDigits;

  // Combine the integer and fractional parts
  return (
    "₹" +
    formattedInt + (
    fractionalPart ? "." + fractionalPart : showZero ? ".00" : ""));

}

export function countFormat(amount: number = 0): string {
  let amountStr = amount.toFixed(2);
  let [integerPart, fractionalPart] = amountStr.split(".");

  // Format the integer part
  let lastThreeDigits = integerPart.slice(-3);
  let otherDigits = integerPart.slice(0, -3);
  if (otherDigits) {
    lastThreeDigits = "," + lastThreeDigits;
  }
  otherDigits = otherDigits.replace(/\B(?=(\d{2})+(?!\d))/g, ",");
  let formattedInt = otherDigits + lastThreeDigits;

  return fractionalPart ? formattedInt : formattedInt;
}

type Timezone = {
  label: string;
  value: number;
};
export const timeZoneList: Timezone[] = [{ label: "India", value: 330 }];

export const questionTypeOptions = [
{
  label: "Select",
  value: "select"
},
{
  label: "File",
  value: "file"
},
// {
//   label: "CheckBox",
//   value: "checkbox",
// },
{
  label: "String",
  value: "string"
},
{
  label: "Boolean",
  value: "boolean"
},
{
  label: "Float",
  value: "float"
}];

export const showToastMessage = (message: string) => {
  return toast.success(message);
};

export const filterOptions = {
  validity: [
  { label: "All", value: "all" },
  { label: "Live", value: "live" },
  { label: "Expiring Soon", value: "expiring_soon" },
  { label: "Expired", value: "expired" },
  { label: "Not Set", value: "not_set" }],

  deviceTypes: [
  { label: "All", value: "" },
  { label: "BP monitor", value: "bp_monitor" },
  { label: "Vincense", value: "vincense" },
  { label: "Glucometer", value: "glucometer" },
  { label: "Weighing Scale", value: "weighing_scale" },
  { label: "ECG", value: "ecg" }],

  operator: [
  { label: "All", value: "all" },
  { label: "Assigned", value: "assigned" },
  { label: "Unassigned", value: "unassigned" }],

  slaOptions: [
  { label: "All", value: "all" },
  { label: "Accepted", value: "active" },
  { label: "Pending", value: "pending" }],

  clientStatus: [
  { label: "All", value: "all" },
  { label: "Archived", value: "archived" },
  { label: "Un Archived", value: "unarchived" }],

  subjectStatus: [
  { label: "All", value: "all" },
  { label: "Active", value: "active" },
  { label: "Archived", value: "archived" }],

  organizationStatus: [
  { label: "All", value: "all" },
  { label: "Active", value: "active" },
  { label: "Archived", value: "archived" }],

  clientType: [
  { label: "All", value: "all" },
  { label: "Screening", value: "screening" },
  { label: "Monitoring", value: "monitoring" },
  { label: "VitAlert", value: "vitalert" },
  { label: "Channel Partner", value: "channel_partner" }],

  gender: [
  { label: "All", value: "" },
  { label: "Male", value: "male" },
  { label: "Female", value: "female" },
  { label: "Other", value: "other" }],

  bloodGroup: [
  { label: "A+", value: "a_positive" },
  { label: "A-", value: "a_negative" },
  { label: "B+", value: "b_positive" },
  { label: "B-", value: "b_negative" },
  { label: "AB+", value: "ab_positive" },
  { label: "AB-", value: "ab_negative" },
  { label: "O+", value: "o_positive" },
  { label: "O- ", value: "o_negative" }],

  subjectTypes: [
  { label: "General", value: "general" },
  { label: "ANC", value: "anc" }],

  viewReadingsOptions: [
  { label: "All Reading", value: "all_reading" },
  { label: "Last Reading ", value: "last_reading" }],

  ncdTypeOptions: [
  // { value: "Normal", label: "Normal" },
  { value: "", label: "All" },
  { value: "suspected", label: "Suspected" },
  { value: "confirmed_dm", label: "Confirmed DM Only" },
  { value: "confirmed_ht", label: "Confirmed HT Only" },
  { value: "confirmed_dm_ht", label: "Confirmed DM & HT" },
  { value: "confirmed", label: "All Confirmed" }],

  ncdConfirmedTypeOptions: [
  // { value: "suspected", label: "Suspected" },
  { value: "confirmed_dm", label: "Confirmed DM Only" },
  { value: "confirmed_ht", label: "Confirmed HT Only" },
  { value: "confirmed_dm_ht", label: "Confirmed DM & HT" }]

};

export const getDeviceTypes: any = {
  maximumBpMonitorDevices: "bp_monitor",
  maximumVincenseDevices: "vincense",
  maximumWeighingScaleDevices: "weighing_scale",
  maximumEcgDevices: "ecg",
  maximumGlucometerDevices: "glucometer"
};

export const getAgeCalculate = (dob: string) => {
  let getDob = Number(moment(dob).format("YYYY"));
  let getCurrent = Number(moment(new Date()).format("YYYY"));
  return (getCurrent - getDob).toString();
};

export const validityColor = (date: any) => {
  let currentDate = moment();
  let effectiveTillDate = moment(date);
  const daysUntilExpiry = effectiveTillDate.diff(currentDate, "days");

  if (effectiveTillDate.isBefore(currentDate)) {
    // Expired
    return {
      color: "#ea5e5e",
      className: "client-kit-transfer-first-card-footer-container_content",
      transferClassName: "client-kit-transfer-card-footer-container_content",
      label: "Worker",
      iconColor: "white"
    };
  } else if (daysUntilExpiry <= 30) {
    //Expiring soon
    return {
      color: "#e9ad7b",
      className: "client-kit-transfer-first-card-footer-container_content",
      transferClassName: "client-kit-transfer-card-footer-container_content",
      label: "Workers",
      iconColor: "white"
    };
  } else if (daysUntilExpiry > 30) {
    // Live
    return {
      color: "#619e61",
      className: "client-kit-transfer-first-card-footer-container_content",
      label: "Workers",
      transferClassName: "client-kit-transfer-card-footer-container_content",
      iconColor: "white"
    };
  } else {
    return {
      color: "white",
      className: "client-kit-transfer-first-card-footer-container_content",
      transferClassName: "client-kit-transfer-card-footer-container_content",
      label: "Workers",
      iconColor: "black"
    };
  }
};

export const deviceImages: {[key: string]: any;} = {
  vincense: VINCENSE_ICON,
  bpMonitor: BP_ICON,
  bp_monitor: BP_ICON,
  weighingScale: WEIGHT_ICON,
  weighing_scale: WEIGHT_ICON,
  ecg: ECG_ICON,
  glucometer: GLUCO_ICON
};

export const bloodGroupObject: {[key: string]: string;} = {
  aPositive: "A+",
  aNegative: "A-",
  bPositive: "B+",
  bNegative: "B-",
  abPositive: "AB+",
  abNegative: "AB-",
  oPositive: "O+",
  oNegative: "O- "
};

import dayjs from "dayjs";
import { startCase } from "lodash";
import { Subject, SubjectDoctorLog, SubjectNote } from "@src/redux/index";

export const readingDateDisableCondition = (
current: any,
validDates: string[])
: boolean => {
  return !validDates.some((date) => dayjs(date).isSame(current, "day"));
};

export const colors: any = {
  excellent: "#3f86cf",
  //very_good: "#25d490",
  veryGood: "#17a88e",
  //very_bad: "#ff9446",
  good: "#9ed144",
  bad: "#ffcd46",
  veryBad: "#ee4421",
  poor: "#861600"
};
const GetColorByType = (
type:
"primary" |
"indigo" |
"pink" |
"lightblue" |
"amber" |
"blue" |
"green" |
string)
: string => {
  let color: string;

  switch (type) {
    case "primary":
      color = "#0cc2aa";
      break;
    case "indigo":
      color = "#3f51b5";
      break;
    case "pink":
      color = "#e91e63";
      break;
    case "lightblue":
      color = "#03a9f4";
      break;
    case "amber":
      color = "#ffc107";
      break;
    case "blue":
      color = "#2196f3";
      break;
    case "green":
      color = "#4caf50";
      break;
    default:
      color = "darkgray";
      break;
  }

  return color;
};

export async function exportDoctorNotesToPDF(
doctorNotes: SubjectNote[],
subjectDetail?: Subject,
RootOrganizationName?: string,
RootOrganizationShortName?: string,
RootOrganizationLogoUrl?: string)
: Promise<void> {
  toast.remove("Please wait while we are generating the report for you");

  let VincenseLogo: string | null = null;
  try {
    VincenseLogo = HEADER_LOGO;
  } catch (ex) {}

  let OrganizationLogo: string | null = null;
  if (RootOrganizationLogoUrl) {
    try {
      OrganizationLogo = RootOrganizationLogoUrl;
    } catch (ex) {}
  }

  const age = await getAgeCalculate(subjectDetail?.dob?.toString() || "");
  const lastLevel = "";

  let numberOfPages = Math.ceil(doctorNotes.length / 4);
  let currentLength = 0;
  const pdf = new jsPDF("p", "px", "a4", true);

  for (let i = 1; i <= numberOfPages; i++) {
    const pageNo = i.toString();
    let y = 0;
    pdf.setFont("courier", "bold");
    pdf.setFontSize(18);
    pdf.text(
      RootOrganizationName && RootOrganizationName?.length < 20 ?
      RootOrganizationName + " Doctor Notes" :
      RootOrganizationShortName + " Doctor Notes",
      230,
      25,
      { align: "center" }
    );

    pdf.setFontSize(13);
    pdf.text("NAME:", 20, 50);
    pdf.text(subjectDetail?.name || "", 70, 50);
    pdf.text("REF:", 190, 50);
    pdf.text(subjectDetail?.updateReferenceId || "", 220, 50);
    pdf.text("GENDER:", 20, 70);
    pdf.text(startCase(subjectDetail?.gender || ""), 70, 70);
    pdf.text("AGE:", 190, 70);
    pdf.text(age, 220, 70);
    pdf.text(lastLevel, 20, 90);

    if (OrganizationLogo) {
      pdf.addImage(OrganizationLogo, "PNG", 330, 40, 100, 50);
    }

    pdf.setLineWidth(0.005);
    pdf.line(20, 110, 430, 110);

    let x = 20;
    y = 120;
    pdf.setLineWidth(1.0);

    const start = (i - 1) * 4;
    const end = Math.min(start + 4, doctorNotes.length);

    for (
    let doctorNoteIndex = start;
    doctorNoteIndex < end;
    doctorNoteIndex++)
    {
      const doctorNote = doctorNotes[doctorNoteIndex];
      pdf.setFillColor(233, 240, 245);
      pdf.circle(x, y + 22, 7, "FD");
      pdf.line(x, y + 29, x, y + 125);

      pdf.setFillColor(GetColorByType(subjectDetail?.subjectType || ""));
      pdf.rect(x + 17, y + 15, 393, 30, "FD");
      pdf.setTextColor("white");
      const date = moment(doctorNote.datetime).format("DD-MMM-YYYY hh:mm a");
      pdf.text(date, x + 20, y + 27);
      pdf.text(doctorNote.noteBy?.name || "", x + 20, y + 40);

      pdf.rect(x + 17, y + 45, 393, 70);
      pdf.setTextColor("black");
      const splitTitle = pdf.splitTextToSize(doctorNote?.content || "", 370);
      pdf.text(splitTitle || " - ", 40, y + 55);
      y += 110;
      currentLength++;

      if (currentLength === doctorNotes.length) {
        break;
      }
    }

    pdf.line(20, 590, 430, 590);
    pdf.text("PAGE:", 20, 605);
    pdf.text(`${pageNo} of ${numberOfPages}`, 55, 605);
    pdf.text("Powered by MedIoTek Health Systems Pvt Ltd.", 20, 620);

    if (VincenseLogo) {
      pdf.addImage(VincenseLogo, "PNG", 320, 600, 100, 25);
    }

    if (i !== numberOfPages) {
      pdf.addPage();
    }
  }

  pdf.save(`Vincense Doctor Notes - ${subjectDetail?.updateReferenceId}.pdf`);
}

export const getSkinValue = (
  value: number | null | undefined,
  withUnit: boolean,
  emptyValue: string = ""
): string => {
  if (value != null) {
    const fahrenheit = (value * 1.8 + 32).toFixed(1);
    return `${value}${withUnit ? "°C" : ""} / ${fahrenheit}${withUnit ? "°F" : ""}`;
  }
  return emptyValue;
};

export const getVitalColorCode = (
color?: string | null,
variant: boolean = false) =>
{
  var colorCode = "#ccd4de";
  if (color) {
    // Normalize all whitespace AND underscores so semantic names coming from
    // the API ("dark_red", "dark red") collapse to a single token that matches
    // the cases below. Previously only the first space was stripped, so
    // "dark_red" never matched "darkred" and critical readings silently fell
    // through to the default colour (rendered as the theme primary, i.e. green).
    color = color.replace(/[\s_]+/g, "");
    color = color.toLowerCase();
  }

  switch (color) {
    case "green":
      if (variant) {
        colorCode = "#37b137";
      } else {
        colorCode = "#4dad4d";
      }
      break;
    case "orange":
      colorCode = "#eab95d";
      if (variant) {
        colorCode = "#eab95d";
      } else {
        colorCode = "#f3bc56";
      }
      break;
    case "red":
      colorCode = "#ff8686";
      if (variant) {
        colorCode = "#ff8686";
      } else {
        colorCode = "#e98c8c";
      }

      break;
    case "yellow":
      if (variant) {
        colorCode = "#cfcf40";
      } else {
        colorCode = "#c3c33d";
      }
      break;
    case "darkred":
      if (variant) {
        colorCode = "#bd6363";
      } else {
        colorCode = "#b15c5c";
      }
      break;
    default:
      colorCode = "#ccd4de";
      break;
  }
  return colorCode;
};

export const getRiskTypeColor: any = {
  yes: "#e57273",
  no: "white",
  nan: "#d7d7d7"
};
export const getRiskTypeTextColor: any = {
  yes: "white",
  no: "black",
  nan: "b"
};
export const sugarValueCalculate = (value: number) => {
  if (value && Number(value) > 600) {
    return ">600";
  } else if (value && Number(value) <= 600) {
    return value.toString() || "-";
  }
};
export const encodeImageFileAsUrl = async (
url: string)
: Promise<string> => {
  // Fetch the image data
  const response = await fetch(url);

  if (!response.ok) {
    throw new Error(`Failed to fetch the image: ${response.statusText}`);
  }

  // Read the image as a Blob
  const blob = await response.blob();

  // Convert the Blob to a Base64 data URL using FileReader
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      if (reader.result) {
        resolve(reader.result.toString());
      } else {
        reject(new Error("Failed to read the image as a Data URL."));
      }
    };
    reader.onerror = (error) => reject(error);
    reader.readAsDataURL(blob);
  });
};

export const findPath = (
routes: any[],
targetKey: string,
parentPath: string = "")
: string | null => {
  for (const route of routes) {
    const fullPath = `${parentPath}/${route.path}`.replace(/\/+/g, "/");

    if (route.key === targetKey) {
      return fullPath;
    }

    if (route.children) {
      const childPath = findPath(route.children, targetKey, fullPath);
      if (childPath) {
        return childPath;
      }
    }
  }
  return null;
};

export const calculatePercentage = (
totalVincenseSubjectCount: number,
totalSubjectCount: number)
: any => {
  if (totalSubjectCount === 0) {
    // Avoid division by zero
    return 0;
  }
  return Number(totalVincenseSubjectCount / totalSubjectCount * 100).toFixed(
    2
  );
};

export function isEmptyObject(obj: any) {
  return Object.keys(obj).length === 0 && obj.constructor === Object;
}

// Served from the V3 excel bucket/CDN. This previously hardcoded the legacy
// vincense-excel-export bucket, which is V1/V2 data.
const excelCdnUrl = (process.env.REACT_APP_EXCEL_CDN_URL ?? "").replace(
  /\/+$/,
  ""
);
export const excelFormatUrl = excelCdnUrl
  ? `${excelCdnUrl}/subject_upload.xlsx`
  : "";